import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { Workbox } from 'workbox-window';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
function loadServiceWorker() {
    if ('serviceWorker' in navigator && environment.production) {
        const wb = new Workbox('/sw.js', { scope: '/' });
        wb.register();
    }
}
if (environment.production) {
    enableProdMode();
}
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .then(_ => loadServiceWorker())
    .catch(err => console.error(err));
